/**
 * 在地图上显示 Street 信息
 * 
 * @Author: Focci
 * @Date: 2023-08-01 13:52:40
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-01 13:52:40
 */

'use client'

import PropTypes from 'prop-types'
import useFetch from '@hook/useFetch'
import useApp from '@hook/useApp'
import { useMap } from 'react-map-gl'
import { PolyLine, fitBoundsDelay } from '@comp/mapbox'
import { isArray } from 'lodash-es'
import { useEffect, useMemo } from 'react'

export function StreetInfoBody({ data }) {
  const { isMobile } = useApp()
  const { current: mapbox } = useMap()

  const hasBoundary = useMemo(() => (
    isArray(data?.boundaries) && data.boundaries.length > 0
  ), [data.boundaries])

  useEffect(() => {
    if(hasBoundary) {
      fitBoundsDelay(mapbox, data?.boundaries, isMobile ? 50 : 300)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.boundaries, hasBoundary])

  return hasBoundary && data.boundaries.map((bound, index) => (
    <PolyLine key={index} data={bound} />
  ))
}

export default function StreetInfo({
  streetId = null
}) {
  const { data } = useFetch(`street/${streetId}`)
  return <StreetInfoBody data={data} />
}

StreetInfo.propTypes = {
  streetId: PropTypes.number,
}
